(() => {
  if (window.fvHeaderSearchInstalled) return;
  window.fvHeaderSearchInstalled = true;
  function init(root) {
    root.querySelectorAll('[data-fv-header-search]').forEach((search) => {
      if (search.dataset.ready) return;
      search.dataset.ready = 'true';
      const form = search.querySelector('form');
      const input = form.querySelector('[name="q"]');
      input.addEventListener('focus', () => {
        search.closest('header').querySelectorAll('details[open]').forEach(menu => { menu.open = false; });
      });
      form.addEventListener('submit', (event) => {
        input.value = input.value.trim();
        if (!input.value) { event.preventDefault(); input.reportValidity(); input.focus(); }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
